import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';

const Modal = ({ isOpen, onClose, children , listenForEscape = true}) => {

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        // 2. Solo añadimos el "oyente" si la prop 'listenForEscape' es verdadera
        if (isOpen && listenForEscape) {
            document.addEventListener('keydown', handleKeyDown);
        }

        // La función de limpieza se asegura de quitar el "oyente" si se añadió
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    // 3. Añadimos 'listenForEscape' a las dependencias del efecto
    }, [isOpen, onClose, listenForEscape]);

    if (!isOpen) {
        return null;
    }

    return (
        // Fondo oscuro (overlay)
        <div 
            className="fixed inset-0 bg-black bg-opacity-60 z-40 flex justify-center items-center"
            onClick={onClose} // Cierra el modal si se hace clic en el fondo
        >
            {/* Contenedor del Modal */}
            <div
                className="bg-white rounded-xl shadow-2xl flex flex-col w-full max-w-screen-xl h-full max-h-[90vh] relative z-50"
                onClick={(e) => e.stopPropagation()} // Evita que el clic dentro del modal lo cierre
            >
                {/* Botón para cerrar el modal */}
                <button
                    onClick={onClose}
                    className="absolute top-2 right-2 p-1 rounded-full text-gray-500 hover:bg-gray-200 hover:text-gray-800 transition-colors z-50"
                    aria-label="Cerrar modal"
                >
                    <X size={24} />
                </button>
                
                {/* Contenido que se pasará al modal (en nuestro caso, el ChatComponent) */}
                <div className="w-full h-full overflow-hidden rounded-xl">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Modal;